import React from 'react'
import { VuiButton } from '@topkamera/viso-ui'

const NotificationSettingsFooter = ({
  onSave, onCancel, isTouched, isSaving
}) => {

  return (
    <div className='vui-flex vui-gap-12 vui-justify-end vui-px-40 vui-pb-60 vui-pt-28'>
      <VuiButton
        label='Cancel'
        onClick={onCancel}
        disabled={!isTouched || isSaving}
      />
      <VuiButton
        label='Save'
        onClick={onSave}
        disabled={!isTouched}
        isLoading={isSaving}
        color='accent0'
        style='filled'
        radius='pill'
      />
    </div>
  )
}

export default NotificationSettingsFooter